import $ from 'jquery';
import 'slick-carousel';

export default () => {
  let $teamSwiper = $('#team-swiper');
  let $previousTeam = $teamSwiper.find('.icon-prev')
  let $nextTeam = $teamSwiper.find('.icon-next')

  if ($('.team-block .team-wrapper .member').length > 1) {
    $('#slider .slides').not('.slick-initialized').slick({
      lazyLoad: 'progressive',
      arrows: false,
      dots: false,
      speed: 500,
      infinite: true,
      cssEase: 'ease-in-out',
      swipe: false,
      fade: true,
      slidesToShow: 1,
      asNavFor: '#slider-overlay .slides, .slick-dots-thumb',
      responsive: [
      {
        breakpoint: 992,
        settings: {
          swipe: true,
        },
      },
      ],
    });
    let number_of_members = $('#slider-overlay .slides .nav-member').length
    $('#slider-overlay .slides').not('.slick-initialized').slick({
      lazyLoad: 'progressive',
      arrows: true,
      dots: false,
      prevArrow: $previousTeam,
      nextArrow: $nextTeam,
      speed: 500,
      infinite: true,
      cssEase: 'ease-in-out',
      slidesToShow: (number_of_members < 3) ? 1 : 2,
      slidesToScroll: 1,
      asNavFor: '#slider .slides, .slick-dots-thumb',
      //initialSlide: (number_of_members < 3) ? 0 : 1,
    });

    if (number_of_members < 3) {
      $('#slider-overlay').removeClass('col-lg-6')
      $('#slider-overlay').addClass('col-lg-3')
    }

    $('.slick-dots-thumb').not('.slick-initialized').slick({
      lazyLoad: 'progressive',
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      centerMode: false,
      cssEase: 'ease-in-out',
      asNavFor: '#slider-overlay .slides, #slider .slides',
      focusOnSelect: true,
    });

    $('#slider-overlay .slides .nav-member .btn-primary.desktop-description').on('click', function() {
      $('#slider-overlay .slides').slick('slickGoTo', $(this).data('slide'))
      if ($(this).hasClass('clicked')) {
        $(this).removeClass('clicked')
        $('#slider .slides .member .btn-primary[data-id="' + $(this).data('id') + '"]').removeClass('clicked')
        $('#slider-overlay .slides .nav-member .btn-primary').text('More')
        $('#slider .slides .member .btn-primary').text('More')

        $('.slick-dots-thumb .content-wrapper').addClass('hidden')
        $('.slick-dots-thumb').slick('resize')
      } else {
        $('#slider-overlay .slides .nav-member .btn-primary').removeClass('clicked')
        $('#slider .slides .member .btn-primary').removeClass('clicked')
        $(this).addClass('clicked')
        $('#slider .slides .member .btn-primary[data-id="' + $(this).data('id') + '"]').addClass('clicked')
        $('#slider-overlay .slides .nav-member .btn-primary').text('More')
        $('#slider .slides .member .btn-primary').text('More')
        $(this).text('Less')
        $('#slider .slides .member .btn-primary[data-id="' + $(this).data('id') + '"]').text('Less')

        //$('.slick-dots-thumb .content-wrapper').addClass('hidden')
        $('.slick-dots-thumb .content-wrapper[data-id="' + $(this).data('id') + '"]').removeClass('hidden')
        $('.slick-dots-thumb').slick('resize')
      }
    })

    $('#slider .slides .member .btn-primary.desktop-description').on('click', function() {
      console.log('yes1');
      if ($(this).hasClass('clicked')) {
        $(this).removeClass('clicked')
        $('#slider-overlay .slides .nav-member .btn-primary[data-id="' + $(this).data('id') + '"]').removeClass('clicked')
        $('#slider-overlay .slides .nav-member .btn-primary').text('More')
        $('#slider .slides .member .btn-primary').text('More')

        $('.slick-dots-thumb .content-wrapper').addClass('hidden')
        $('.slick-dots-thumb').slick('resize')
      } else {
        $('#slider-overlay .slides .nav-member .btn-primary').removeClass('clicked')
        $('#slider .slides .member .btn-primary').removeClass('clicked')
        $(this).addClass('clicked')
        $('#slider-overlay .slides .nav-member .btn-primary[data-id="' + $(this).data('id') + '"]').addClass('clicked')
        $('#slider-overlay .slides .nav-member .btn-primary').text('More')
        $('#slider .slides .member .btn-primary').text('More')
        $(this).text('Less')
        $('#slider-overlay .slides .nav-member .btn-primary[data-id="' + $(this).data('id') + '"]').text('Less')

        $('.slick-dots-thumb .content-wrapper').addClass('hidden')
        $('.slick-dots-thumb .content-wrapper[data-id="' + $(this).data('id') + '"]').removeClass('hidden')
        $('.slick-dots-thumb').slick('resize')
      }
    })
    $('.slick-dots-thumb, #slider .slides, #slider-overlay .slides').on('beforeChange', function(){
      console.log('yes2');
      //$('#slider-overlay .slides .nav-member .btn-primary').removeClass('clicked')
     // $('#slider .slides .member .btn-primary').removeClass('clicked')
      $('#slider-overlay .slides .nav-member .btn-primary').text('Less')
      $('#slider .slides .member .btn-primary').text('Less')

      $('.slick-dots-thumb .content-wrapper').removeClass('hidden')
      $('.slick-dots-thumb').slick('resize')
    })
  } else {
    $('#slider-overlay .slides').hide()
    $teamSwiper.hide()
  }

  $('.slick-dots-thumb').on('swipe', function(){
    console.log('yes3');
    $('.slick-dots-thumb .mobile-description').text('More')
    $('.member__description').removeClass('mobile-display')
    $('.slick-dots-thumb').slick('resize')
  })

  $('.slick-dots-thumb .mobile-description').on('click', function() {
    if ($(this).text() == 'More') {
      $(this).text('Less')
    } else {
      $(this).text('More')
    }
    $(this).next('.member__description').toggleClass('mobile-display')
    $('.slick-dots-thumb').slick('resize')
  })
  
  $('.member__more-link.mobile .mobile-description').on('click', function() {
    if ($(this).text() == 'More') {
      $(this).text('Less')
    } else {
      $(this).text('More')
    }
    $(this).next('.member__description').toggleClass('mobile-display')
  })
  
}



// WEBPACK FOOTER //
// ./scripts/layouts/team-block.js